import React from "react";
import "../styles/menuIntro.css";

export default function MenuIntro() {
  return (
    <section className="menu-intro">
      <div className="container text-center">
        <h1 className="menu-title">Étlap</h1>
        <p className="menu-subtitle">
          Vékony tésztás pizza és gyros kínálatunk
        </p>

        <div className="menu-pill-row">
          <a className="menu-pill" href="#pizzaink">
            Pizzáink
          </a>
          <a className="menu-pill" href="#gyrosaink">
            Gyrosaink
          </a>
          <a className="menu-pill" href="#oriáspalacsintaink">
            Óriáspalacsintáink
          </a>
          <a className="menu-pill" href="#koreteink">
            Köreteink
          </a>
        </div>
      </div>
    </section>
  );
}
